import React, { useEffect, useState } from 'react';
import installI18nContext from 'modules/i18n/installI18nContext';
import { userSelector } from 'modules/currentUser';
import { useSelector } from 'react-redux';
import { mustFillKycProfessionalProfile } from 'models/users.js';
import AlertModalContainer from 'components/AlertModalContainer.jsx';
import ProfessionalProfileCompletionContainer from 'components/ProfessionalProfile/ProfessionalProfileCompletionContainer.jsx';

const UserModalsContainer = () => {
    const user = useSelector(userSelector);
    const [showProfessionalProfile, setShowProfessionalProfile] = useState(false);

    useEffect(() => {
        if (user.anonymous) {
            return;
        }
        mustFillKycProfessionalProfile(user).then(mustDisplayKycProPopup => {
            if (mustDisplayKycProPopup) {
                setShowProfessionalProfile(true);
            }
        });
    }, [user]);

    if (user.anonymous) {
        return null;
    }

    if (showProfessionalProfile) {
        return <ProfessionalProfileCompletionContainer />;
    }

    return <AlertModalContainer />;
};

export default installI18nContext(UserModalsContainer);
